import { compose, withHandlers } from 'recompose';
import { addProps } from 'utils/recompose';
import styles from './styles.module.scss';

export const isSelected = ({ optionKey, selectedDesignOption }) =>
  optionKey === selectedDesignOption;

export const arrowStyles = ({ isSelected }) =>
  isSelected ? styles.triangle : styles.noTriangle;

const chooseElement = ({ optionKey, onClickOrTouch }) => () =>
  onClickOrTouch(optionKey);

export default compose(
  addProps({ isSelected }),
  addProps({ arrowStyles }),
  withHandlers({ chooseElement }),
);
